const { reservation_ref_number_regex } = require('../constants/regexes');

function isReservationIdField(f) {
    return (
        f &&
        f.field_type === 'reservation_id'
        // need more investigations over this feature. There is a conflict with company's settings: 5ffdd2562eba2919c41600fc
        // || (f.field_type === 'text' && reservation_ref_number_regex.test(f.label || ''))
    );
}

module.exports = {
    isReservationIdField,
};
